var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7 0.00855887C24.5893 -0.00285296 24.4777 -0.00285296 24.3669 0.00855887H1.6169C1.4711 0.0108055 1.32625 0.0326684 1.18628 0.0735588L12.9269 11.7654L24.7 0.00855887Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9025 1.1377L14.0725 12.9189C13.768 13.2216 13.3562 13.3915 12.9269 13.3915C12.4976 13.3915 12.0857 13.2216 11.7812 12.9189L0.056875 1.22707C0.020832 1.35954 0.00172143 1.49604 0 1.63332V17.8833C0 18.3143 0.171205 18.7276 0.475951 19.0324C0.780698 19.3371 1.19402 19.5083 1.625 19.5083H24.375C24.806 19.5083 25.2193 19.3371 25.524 19.0324C25.8288 18.7276 26 18.3143 26 17.8833V1.63332C25.9935 1.46404 25.9606 1.29681 25.9025 1.1377ZM2.73813 17.8833H1.60875V16.7214L7.51562 10.8633L8.66125 12.0089L2.73813 17.8833ZM24.3587 17.8833H23.2213L17.2981 12.0089L18.4437 10.8633L24.3506 16.7214L24.3587 17.8833Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.38e5e301a93e2395c8623542cd61ad6b.svg";
export { ForwardRef as ReactComponent };